<template>
  <div class="tag-list d-flex align-items-center" style="flex-wrap: wrap">
    <span
      v-for="(item, key) in tags"
      class="tag text-truncate"
      :title="item.title"
      :key="key">
        {{ item.title }}
        <a-icon style="font-size: 12px;position:absolute;right:3px;top:50%;transform:translateY(-50%)" class="ml-1" type="close" @click="removeTag(item)" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    tagTree: Object,
    withTagKey: {
      type: String,
      default: 'with_user_meta',
    },
    withoutTagKey: {
      type: String,
      default: 'without_user_meta',
    },
  },
  computed: {
    tags () {
      const tags = []
      for (const key in this.tagTree) {
        const values = this.tagTree[key]
        if (key === this.withTagKey) {
          tags.push({
            key: key,
            value: '',
            title: this.$t('common_260'),
          })
        } else if (key === this.withoutTagKey) {
          tags.push({
            key: key,
            value: '',
            title: this.$t('common.with_user_meta'),
          })
        } else if (values.length) {
          const tagValues = values.map(v => v === '___no_value__' ? this.$t('common_736') : v)
          tags.push({
            key: key,
            value: values,
            title: this.$t('bill.text_104', [key.replace('user:', ''), tagValues.join(' or ')]),
          })
        } else {
          tags.push({
            key: key,
            value: '',
            title: this.$t('bill.tag_key_label', [key.replace('user:', '')]),
          })
        }
      }
      return tags
    },
  },
  methods: {
    removeTag (tag) {
      this.$emit('removeTag', tag)
    },
  },
}
</script>

<style lang="less" scoped>
.tag-list {
  margin-top: 10px;;
  .tag {
    max-width: 100%;
    line-height: 20px;
    margin-right: 10px;
    padding: 0 18px 0 4px;
    font-size: 12px;
    border-style: solid;
    border-width: 1px;
    margin-bottom: 10px;
    position: relative;
  }
}
</style>
